<template>
    <div class="ilt-table-content">
        <div class="ilt-table table-responsive">
            <table class="table">
                <thead>
                <tr>
                    <th v-if="showOfferName">Aanbieding</th>
                    <th>Totale toestel kosten</th>

                    <th v-if="isTMobileRecycledDeal">Restbedrag te betalen na contractsuur</th>
                    <th v-else>Eemalige betaling</th>

                    <th>Totaal krediet bedrag</th>
                    <th>Termijn bedrag</th>
                    <th>Duur overeenkomst</th>
                    <th>Vaste rente / JKP</th>
                </tr>
                </thead>

                <tbody>
                <tr>
                    <td v-if="showOfferName">
                        {{ offer.device.display_name }} | {{ offer.provider.name }}
                    </td>

                    <td>
                        {{ currencySymbol }}
                        {{ $filters.formatDecimals(totalDevicePrice) }}
                    </td>

                    <td v-if="isTMobileRecycledDeal">
                        {{ currencySymbol }}
                        {{ $filters.formatDecimals(offer.recycle_deal_remaining_amount) }}
                    </td>

                    <td v-else>
                        {{ currencySymbol }}
                        {{ $filters.formatDecimals(oneTimePrice) }}
                    </td>

                    <td>
                        {{ currencySymbol }}
                        {{ $filters.formatDecimals(totalMonthlyPrice) }}
                    </td>

                    <td>
                        {{ currencySymbol }}
                        {{ $filters.formatDecimals(selectedCategory) }}
                    </td>

                    <td>{{ $filters.pluralize(offer.subscription.duration, ['maand', 'maanden']) }}</td>
                    <td>0%</td>
                </tr>
                </tbody>
            </table>
        </div>

        <div class="under-table-footer-wrap"
             :class="{show: showCreditInfo}"
        >
            <div class="under-table-footer"
                 v-html="offer.provider.credit_info"
            />

            <div v-if="isMobile" class="arrow-wrap">
                <i class="fa fa-angle-down" @click="onShowCreditInfo"/>
            </div>
        </div>
    </div>
</template>

<script>
import {isOdido} from "../helper";
import {useOneTimePrice} from "../composables/oneTimePrice";

export default {
    props: {
        offer: {
            type: Object,
            required: true
        },

        showOfferName: {
            type: Boolean,
            default: true
        },

        category: {
            type: Number,
            required: false
        }
    },

    data() {
        return {
            showCreditInfo: false
        }
    },

    computed: {
        isTMobileRecycledDeal() {
            return isOdido(this.offer.provider.name)
                && this.offer.device.is_recycle_deal
        },

        totalMonthlyPrice() {
            let residualAmount = this.isTMobileRecycledDeal
                ? this.offer.recycle_deal_remaining_amount
                : 0

            return parseFloat(this.selectedCategory)
                * this.offer.subscription.duration
                + parseFloat(residualAmount)
        },

        selectedCategory() {
            return this.category || this.offer.monthly_price_category
        },

        oneTimePrice() {
            return useOneTimePrice(this.offer, this.selectedCategory)
        },

        totalDevicePrice() {
            let residualAmount = this.isTMobileRecycledDeal
                ? this.offer.recycle_deal_remaining_amount
                : 0

            return parseFloat(this.totalMonthlyPrice) + parseFloat(this.oneTimePrice) - residualAmount
        }
    },

    methods: {
        onShowCreditInfo() {
            this.showCreditInfo = !this.showCreditInfo
        }
    }
}
</script>
